import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import {
  Grid,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import readXlsxFile from "read-excel-file";
import XLSX from "sheetjs-style";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { dynamiceForm } from "../../../actions/DynamiceForm";
import LoadingComponent from "../../CommonComponents/LoadingComponent";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment/moment";
let finalArrayData = [];

export default function ImportExcel({
  openModal,
  setOpenModal,
  closeExcelImportModal,
  exportArray,
  templateData,
  templateMAterID,
  fetchClientList,
}) {
  const localData = JSON.parse(localStorage.getItem("data")) || {};
  console.log("templateData: ", templateData);
  const [loading, setLoading] = React.useState(false);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("md");
  const [multiVehicles, setMultiVehicles] = React.useState([]);
  const [count, setCount] = React.useState(0);
  const [file, setFile] = React.useState();
  const [show, setShow] = React.useState(false);
  const [FormData, setFormData] = React.useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [failedDataToExport, setFailedDataToExport] = React.useState([]);
  console.log(failedDataToExport, "failedDataToExport");

  const removeFile = () => {
    setFile(null);
    setMultiVehicles([]);
    const input = document.getElementById("inputFile");
    if (input?.value) {
      input.value = "";
    }
  };

  const handleCancel = () => {
    closeExcelImportModal();
    setShow(false);
    setMultiVehicles([]);
    fetchClientList(true);
    setFailedDataToExport([]);
  };
  let batchSize = 1000;
  const totalItems = multiVehicles?.clientDtoList?.length;
  let currentIndex = 0;
  const handleUpdate = async () => {
    if ((totalItems ?? 0) > batchSize) {
      alert("Maximum 1000 records are allowed!");
      return;
    }
    while (currentIndex < totalItems) {
      const batch = multiVehicles?.clientDtoList?.slice(
        currentIndex,
        currentIndex + batchSize
      );

      if (Array.isArray(batch)) {
        try {
          // Make an API request here to send the batch of data to your API
          await addVehicle(batch);

          console.log(
            `Sent batch from index ${currentIndex} to ${
              currentIndex + batchSize - 1
            }`
          );
        } catch (error) {
          console.error("Error sending batch:", error);
        }

        currentIndex += batchSize;
      } else {
        console.error("multiVehicles.clientDtoList is not an array.");
        break;
      }
    }
  };

  const addVehicle = (value, index) => {
    if (file == undefined || file == null) {
      alert("Please Choose Excel File");
      return false;
    }
    setLoading(true);
    const clientDtoList = value;
    let tempResponseClientDtoList = [];

    dynamiceForm
      .fetchExcelImport({
        hrmsCompanyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
        clientDtoList,
      })
      .then((response) => {
        if (response !== null) {
          setShow(true);

          const countToSet =
            response?.data &&
            response?.data.filter((val) => val.isClientImported == true);
          // setMultiVehicles({ clientDtoList: response?.data });
          // tempResponseClientDtoList = [
          //   ...tempResponseClientDtoList,
          //   ...(response?.data || []),
          // ];
          tempResponseClientDtoList = [
            ...tempResponseClientDtoList,
            // ...(response?.data ? response.data : []),
            ...(Array.isArray(response.data) ? response.data : []),
          ];
          const failedDataToExportToSet =
            response?.data &&
            response?.data.filter((val) => val.isClientImported == false);
          // setFailedDataToExport(failedDataToExportToSet);
          setFailedDataToExport((prevFailedData) => [
            ...prevFailedData,
            ...failedDataToExportToSet,
          ]);
          setCount((prev) => (countToSet ? prev + countToSet.length : prev));
          setLoading(false);
        } else {
          setMultiVehicles([]);
          setLoading(false);
        }
      })
      .finally(() => {
        setMultiVehicles((prevState) => {
          const prevClientDtoList = Array.isArray(prevState?.clientDtoList)
            ? prevState.clientDtoList
            : [];

          const responseClientDtoList = Array.isArray(tempResponseClientDtoList)
            ? tempResponseClientDtoList
            : [];

          return {
            ...prevState,
            clientDtoList: [...prevClientDtoList, ...responseClientDtoList],
          };
        });
      });
    // .finally(() => {
    //   setMultiVehicles((prevState) => ({
    //     ...prevState,
    //     clientDtoList: [
    //       ...prevState?.clientDtoList,
    //       ...tempResponseClientDtoList,
    //     ],
    //   }));
    // });
    setMultiVehicles({ clientDtoList: tempResponseClientDtoList });
  };
  // handleUpdate()
  console.log(multiVehicles, "multiVehiclesfghjn");

  const getFormData = (value) => {
    const formDataToSet = [];

    templateData &&
      templateData.forEach((preview) => {
        // console.log(preview.children.column2, "djbjhwbddv");
        preview.children.column1.forEach((child) => {
          // formDataToSet[child.name]=getInputDefaultVal(child.compName);
          formDataToSet.push({
            label: child.label,
            value: "",
            name: child.name,
            mandetoryName: child.mandetoryName,
            isHidden: child.isHidden,
            uid: child.uid,
            compName: child.compName,
          });
        });
        preview.children.column2.forEach((child) => {
          // formDataToSet[child.name]=getInputDefaultVal(child.compName);
          formDataToSet.push({
            label: child.label,
            value: "",
            name: child.name,
            mandetoryName: child.mandetoryName,
            isHidden: child.isHidden,
            uid: child.uid,
            compName: child.compName,
          });
        });
      });
    // setPreviews(previewData);
    const finalArray =
      formDataToSet && formDataToSet.filter((val) => val.isHidden == false);
    setFormData(finalArray);
  };

  const onFIleChange = () => {
    // setMultiVehicles([]);
    debugger;
    const input = document.getElementById("inputFile");
    if (Boolean(input.files[0])) {
      if (getFileExtension(input.files[0].name) !== "xlsx") {
        input.value = "";
        setFile(null);
        setMultiVehicles([]);
        return alert("Please Select an Excel File.");
      }
      setFile(input.files[0]);
      setLoading(true);
      readXlsxFile(input.files[0]).then((rawRows) => {
        const rows = rawRows.map((parentRow) => [
          ...parentRow.map((childRow) =>
            childRow instanceof Date
              ? moment(childRow).format("DD/MM/YYYY")
              : childRow
          ),
        ]);
        const headers =
          rows && rows[0].filter((header) => header !== "Emp Code");
        // const finalHeaders = headers.pop();
        const values = rows.slice(1);
        console.log(FormData, headers, values, "fgvbhjnkml");
        console.log("values: ", values);

        if (FormData.length !== headers.length) {
          alert("Please upload valid template");
          setLoading(false);
          input.value = "";
          setFile(null);
          setMultiVehicles([]);
          return false;
        }

        if (Array.isArray(values) && !Boolean(values?.length)) {
          alert("Uploaded template is empty");
          setLoading(false);
          input.value = "";
          setFile(null);
          setMultiVehicles([]);
          return false;
        }

        if (FormData && FormData.length > 0) {
          const mandetoryFields = {};
          values.forEach((row, rowInd) => {
            row.forEach((col, ind) => {
              if (/\*$/.test(headers[ind]) && !Boolean(col)) {
                // mandetoryFields.add(headers[ind]);
                if (Boolean(mandetoryFields[headers[ind]])) {
                  mandetoryFields[headers[ind]] =
                    mandetoryFields[headers[ind]] +
                    `, ${colName(ind)}${rowInd + 2}`;
                } else {
                  mandetoryFields[headers[ind]] = `${colName(ind)}${
                    rowInd + 2
                  }`;
                }
              }
            });
          });

          if (Boolean(Object.values(mandetoryFields).length)) {
            setLoading(false);
            input.value = "";
            setFile(null);
            setMultiVehicles([]);
            let resultMsg = "";
            Object.keys(mandetoryFields).forEach((key) => {
              resultMsg += Boolean(resultMsg)
                ? `, ${key} (${mandetoryFields[key]})`
                : `${key} (${mandetoryFields[key]})`;
            });
            return alert(resultMsg + " can not be blank.");
          }

          const matchedPanNoObj =
            FormData?.find((item) => item?.mandetoryName === "panno") || null;

          console.log("matchedPanNoObj: ", matchedPanNoObj);

          if (
            Boolean(matchedPanNoObj?.label) &&
            Boolean(headers?.length) &&
            Boolean(
              headers?.some(
                (header) =>
                  header?.replace(/\*$/, "") === matchedPanNoObj?.label
              )
            )
          ) {
            // const indexOfPanNo = headers?.indexOf(matchedPanNoObj?.label);
            const indexOfPanNo = headers?.findIndex(
              (header) => header?.replace(/\*$/, "") === matchedPanNoObj?.label
            );
            let uniquePanNos = [];
            let duplicatePanNos = [];

            console.log(
              "PAN NO RES: ",
              indexOfPanNo,
              uniquePanNos,
              duplicatePanNos
            );

            values.forEach((row) => {
              row.forEach((col, ind) => {
                if (Boolean(indexOfPanNo === ind) && Boolean(col)) {
                  if (
                    uniquePanNos?.some(
                      (uniquePanItem) =>
                        uniquePanItem?.toString()?.toLowerCase() ===
                        col?.toString()?.toLowerCase()
                    ) &&
                    !duplicatePanNos?.some(
                      (duplicatePanItem) =>
                        duplicatePanItem?.toString()?.toLowerCase() ===
                        col?.toString()?.toLowerCase()
                    )
                  ) {
                    duplicatePanNos?.push(col);
                  } else {
                    uniquePanNos?.push(col);
                  }
                }
              });
            });

            if (Boolean(duplicatePanNos?.length)) {
              setLoading(false);
              input.value = "";
              setFile(null);
              setMultiVehicles([]);
              return alert(
                "Invalid excel due to Duplicate PAN numbers: " +
                  duplicatePanNos?.join(", ")
              );
            }
          }

          const matchedGstNoObj =
            FormData?.find((item) => item?.mandetoryName === "gstno") || null;

          console.log("matchedGstNoObj: ", matchedGstNoObj);

          if (
            Boolean(matchedGstNoObj?.label) &&
            Boolean(headers?.length) &&
            Boolean(
              headers?.some(
                (header) =>
                  header?.replace(/\*$/, "") === matchedGstNoObj?.label
              )
            )
          ) {
            // const indexOfGstNo = headers?.indexOf(matchedGstNoObj?.label);
            const indexOfGstNo = headers?.findIndex(
              (header) => header?.replace(/\*$/, "") === matchedGstNoObj?.label
            );
            let uniqueGstNos = [];
            let duplicateGstNos = [];
            console.log(
              "GST NO RES: ",
              indexOfGstNo,
              uniqueGstNos,
              duplicateGstNos
            );

            values.forEach((row) => {
              row.forEach((col, ind) => {
                if (Boolean(indexOfGstNo === ind) && Boolean(col)) {
                  if (
                    uniqueGstNos?.some(
                      (uniqueGstItem) =>
                        uniqueGstItem?.toString()?.toLowerCase() ===
                        col?.toString()?.toLowerCase()
                    ) &&
                    !duplicateGstNos?.some(
                      (duplicateGstItem) =>
                        duplicateGstItem?.toString()?.toLowerCase() ===
                        col?.toString()?.toLowerCase()
                    )
                  ) {
                    duplicateGstNos?.push(col);
                  } else {
                    uniqueGstNos?.push(col);
                  }
                }
              });
            });

            if (Boolean(duplicateGstNos?.length)) {
              setLoading(false);
              input.value = "";
              setFile(null);
              setMultiVehicles([]);
              return alert(
                "Invalid excel due to Duplicate GST numbers: " +
                  duplicateGstNos?.join(", ")
              );
            }
          }

          const matchedPhoneNoObj =
            FormData?.find((item) => item?.mandetoryName === "phoneNo") || null;

          console.log("matchedPhoneNoObj: ", matchedPhoneNoObj);

          if (
            Boolean(matchedPhoneNoObj?.label) &&
            Boolean(headers?.length) &&
            Boolean(
              headers?.some(
                (header) =>
                  header?.replace(/\*$/, "") === matchedPhoneNoObj?.label
              )
            )
          ) {
            const indexOfPhoneNo = headers?.findIndex(
              (header) =>
                header?.replace(/\*$/, "") === matchedPhoneNoObj?.label
            );
            let uniquePhoneNos = [];
            let duplicatePhoneNos = [];
            console.log(
              "PHONE NO RES CHECK: ",
              indexOfPhoneNo,
              uniquePhoneNos,
              duplicatePhoneNos
            );

            values.forEach((row) => {
              row.forEach((col, ind) => {
                if (Boolean(indexOfPhoneNo === ind) && Boolean(col)) {
                  if (
                    uniquePhoneNos?.some(
                      (uniquePhoneItem) =>
                        uniquePhoneItem?.toString()?.toLowerCase() ===
                        col?.toString()?.toLowerCase()
                    ) &&
                    !duplicatePhoneNos?.some(
                      (duplicatePhoneItem) =>
                        duplicatePhoneItem?.toString()?.toLowerCase() ===
                        col?.toString()?.toLowerCase()
                    )
                  ) {
                    duplicatePhoneNos?.push(col);
                  } else {
                    uniquePhoneNos?.push(col);
                  }
                }
              });
            });

            // if (Boolean(duplicatePhoneNos?.length)) {
            //   setLoading(false);
            //   input.value = "";
            //   setFile(null);
            //   setMultiVehicles([]);
            //   return alert(
            //     "Invalid excel due to Duplicate Phone numbers: " +
            //       duplicatePhoneNos?.join(", ")
            //   );
            // }
          }

          const response = values.map((row, ind) => {
            const newRow =
              headers &&
              headers.length > 0 &&
              headers.map((headerModified, index) => {
                const header = headerModified.replace("*", "").trim();
                return {
                  label:
                    (FormData &&
                      FormData?.filter((item1) =>
                        [header]?.some(
                          (item2) => header && header === item1?.label?.trim()
                        )
                      )
                        .map((val) => val?.label)
                        .toString()) ||
                    "",
                  value: row[index] !== null ? row[index].toString() : "",
                  name:
                    (FormData &&
                      FormData?.filter((item1) =>
                        [header]?.some(
                          (item2) => header && header === item1?.label?.trim()
                        )
                      )
                        .map((val) => val?.name)
                        .toString()) ||
                    "",

                  mandetoryName:
                    FormData &&
                    FormData?.filter((item1) =>
                      [header].some((item2) => header === item1?.label.trim())
                    )
                      .map((val) => val?.mandetoryName)
                      .toString(),

                  uid:
                    (FormData &&
                      FormData?.filter((item1) =>
                        [header].some(
                          (item2) => header === item1?.label?.trim()
                        )
                      )
                        .map((val) => val?.uid)
                        .toString()) ||
                    "",
                  compName:
                    (FormData &&
                      FormData?.filter((item1) =>
                        [header].some(
                          (item2) => header === item1?.label?.trim()
                        )
                      )
                        .map((val) => val?.compName)
                        .toString()) ||
                    "",
                };
              });

            console.log("newRow: ", newRow);

            const finalObj = {
              empCode: row && row[row.length - 1] ? row[row.length - 1] : "NA",
              name:
                newRow &&
                newRow?.find((val) => val.name == "Company Name")?.value,
              contactNo:
                newRow && newRow?.find((val) => val.name == "Phone No")?.value,
              contactPerson:
                newRow &&
                newRow?.find((val) => val.name == "Contact Person")?.value,
              panCardNumber:
                newRow && newRow?.find((val) => val.name == "PAN No")?.value,
              gstNumber:
                newRow && newRow?.find((val) => val.name == "GST No")?.value,
              address:
                newRow && newRow?.find((val) => val.name == " Address")?.value,
              clientStatus:
                newRow &&
                newRow?.find((val) => val.name == "Client Status")?.value,
              visitingCardUrl:
                (newRow &&
                  newRow?.find((val) => val.name == "Visiting Card")?.value) ||
                null,
              userId: JSON.parse(localStorage.getItem("data")).id,
              designation:
                newRow &&
                newRow?.find((val) => val.name == "Designation")?.value,
              typeOfIndustry:
                newRow && newRow?.find((val) => val.name == "type")?.value,
              countryName:
                newRow && newRow?.find((val) => val.name == "Country")?.value,
              city: newRow && newRow?.find((val) => val.name == "City")?.value,
              state:
                newRow && newRow?.find((val) => val.name == "State")?.value,
              website:
                newRow && newRow?.find((val) => val.name == "Website")?.value,
              remark:
                newRow && newRow?.find((val) => val.name == "remarks")?.value,
              latitude: "",
              longitude: "",
              cityId: null,
              stateId: null,
              term_condition: "TermsAndCondition",
              emailId:
                newRow && newRow?.find((val) => val.name == "Email")?.value,
              isFixedClient: false,
              companyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
              clientUpdatedStatusId: 1,
              templateMasterId: templateMAterID,
              formData: newRow && newRow,
              clientFileUrlList: [],
              locality:
                newRow && newRow?.find((val) => val.name == "Locality")?.value,
              type: newRow && newRow?.find((val) => val.name == "type")?.value,
            };

            return finalObj;
          });

          const finalObj1 = {
            hrmsCompanyId: JSON.parse(localStorage.getItem("data"))
              .hrmsCompanyId,
            clientDtoList: response && response,
          };
          // console.log(finalObj1,"finalObj1dfghj")
          setMultiVehicles(finalObj1);
          setLoading(false);
        }

        //   console.log(multiVehicles, "newArray");
      });
    } else {
      setMultiVehicles([]);
    }

    // document.getElementById("inputFile").value = "";
    // getFormData()
  };

  // const onFIleChange = async () => {
  //   const input = document.getElementById("inputFile");
  //   const file = input.files[0];

  //   if (!file) {
  //     alert("Please select a file.");
  //     return;
  //   }

  //   setLoading(true);

  //   try {
  //     const rows = await readXlsxFile(file);
  //     const headers = rows[0].filter((header) => header !== "Emp Code");
  //   // const   finalheaders = headers;
  //     const values = rows.slice(1);
  //     console.log(FormData,'dfgvhbjnkml')

  //     if (FormData.length !== headers.length) {
  //       alert("Please upload a valid template");
  //       setLoading(false);
  //       return;
  //     }

  //     const response = values.map((row) => {
  //       const newRow = headers.map((header, index) => {
  //         const formDataItem = FormData.find((item) =>
  //           header === item.label?.trim()
  //         );
  //         return {
  //           label: formDataItem?.label || "",
  //           value: row[index] !== null ? row[index].toString() : "",
  //           name: formDataItem?.name || "",
  //           mandetoryName: formDataItem?.mandetoryName || "",
  //           uid: formDataItem?.uid || "",
  //           compName: formDataItem?.compName || "",
  //         };
  //       });

  //       return {
  //         empCode: row[row.length - 1] || "NA",
  //         name: newRow.find((val) => val.name === "Company Name")?.value,
  //         contactNo: newRow.find((val) => val.name === "Phone No")?.value,
  //         contactPerson: newRow.find((val) => val.name === "Contact Person")?.value,
  //         panCardNumber: newRow.find((val) => val.name === "PAN No")?.value,
  //         gstNumber: newRow.find((val) => val.name === "GST No")?.value,
  //         address: newRow.find((val) => val.name === "Address")?.value,
  //         userId: JSON.parse(localStorage.getItem("data")).id,
  //         designation: newRow.find((val) => val.name === "Designation")?.value,
  //         typeOfIndustry: newRow.find((val) => val.name === "Type")?.value,
  //         city: newRow.find((val) => val.name === "City")?.value,
  //         state: newRow.find((val) => val.name === "State")?.value,
  //         website: newRow.find((val) => val.name === "Website")?.value,
  //         remark: newRow.find((val) => val.name === "Remarks")?.value,
  //         latitude: "",
  //         longitude: "",
  //         cityId: null,
  //         stateId: null,
  //         visitingCardUrl: "",
  //         term_condition: "TermsAndCondition",
  //         emailId: newRow.find((val) => val.name === "Email")?.value,
  //         isFixedClient: false,
  //         companyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
  //         clientUpdatedStatusId: 1,
  //         templateMasterId: templateMAterID,
  //         formData: newRow,
  //         clientFileUrlList: [],
  //       };
  //     });

  //     const finalObj = {
  //       hrmsCompanyId: JSON.parse(localStorage.getItem("data")).hrmsCompanyId,
  //       clientDtoList: response,
  //     };

  //     setMultiVehicles(finalObj);
  //   } catch (error) {
  //     console.error("Error reading file:", error);
  //     alert("Error reading the file. Please try again.");
  //   } finally {
  //     setLoading(false);
  //     //input.value = ""; // Clear the file input field
  //   }
  // };

  // Function to handle the page change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  // Function to handle the rows per page change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleExportFailedData = () => {
    // const dataToExport = [];
    // failedDataToExport.forEach((data) => {
    //   dataToExport.push({
    //     "Company Name": data.name,
    //     "Contact Person": data.contactPerson,
    //     "Phone No": data.contactNo,
    //     Email: data.emailId,
    //     Designation: data.designation,
    //     Type: data.typeOfIndustry,
    //     "Client Status": data.status,
    //     Website: data.website,
    //     "Visiting Card": data.visitingCardUrl,
    //     "PAN No": data.panCardNumber,
    //     "GST No": data.gstNumber,
    //     Address: data.address,
    //     State: data.state,
    //     City: data.city,
    //     Branch: data.clientBranch,
    //     Remarks: data.remark,
    //     "Emp Code": data.empCode,
    //     // Reason: data.clientImportResponse,
    //   });
    // });
    // exportExcel(dataToExport, "Failed Data");
    const table = document.getElementById("failedData");
    const wb = XLSX.utils.table_to_book(table, { raw: true });
    XLSX.writeFile(wb, "Failed Data.xlsx");
  };

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  React.useEffect(() => {
    getFormData();
  }, [templateData]);

  const DownloadTemplate = () => {
    // getTempalte()
    setTimeout(() => {
      document.getElementById("exportDataList").click();
      // setLoading(false)
    }, 500);
  };

  const handleClose = () => {
    setOpenModal(false);
    setShow(false);
    setMultiVehicles([]);
    setFailedDataToExport([]);
  };

  React.useEffect(() => {
    setCount(0);
  }, [openModal]);

  return (
    <div className="modal">
      <div>
        <Dialog
          open={openModal}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={fullWidth}
          maxWidth={maxWidth}
        >
          <LoadingComponent isLoading={loading} />
          <DialogTitle id="alert-dialog-title">
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span
                className="font14"
                style={{ fontWeight: "bold", marginLeft: "10px" }}
              >
                {"Import Clients By Excel"?.replace(
                  localData?.isClientNameChanged ? /client/gi : "",
                  localData?.isClientNameChanged
                    ? localData?.changedClientFieldName
                    : ""
                )}
              </span>
              <div
                onClick={DownloadTemplate}
                style={{ color: "blue", cursor: "pointer" }}
              >
                {/* <a className="float-right" href={""} download> */}
                {"Download Clients Excel Template"?.replace(
                  localData?.isClientNameChanged ? /client/gi : "",
                  localData?.isClientNameChanged
                    ? localData?.changedClientFieldName
                    : ""
                )}
                {/* </a> */}
              </div>
            </div>
          </DialogTitle>

          <DialogContent dividers>
            <DialogContentText
              id="alert-dialog-description"
              className="modal-content"
            >
              <Grid
                container
                // spacing={3}
                style={{ marginLeft: "10px", marginBottom: "2px" }}
              >
                {!show && (
                  <Grid item xs={12} md={4.5} lg={4.5}>
                    <>
                      <Typography
                        className="font14 greyfirstheading"
                        gutterBottom
                        variant="subtitle1"
                      >
                        Import Excel
                      </Typography>
                      <Typography variant="body2" gutterBottom className="py-2">
                        {/* <Typography component="span"></Typography>
                        <Typography component="span"></Typography> */}
                        <input
                          type="file"
                          id="inputFile"
                          accept=".xlsx"
                          onChange={onFIleChange}
                        />
                        <span>
                          {Boolean(multiVehicles?.clientDtoList?.length) &&
                            !show && (
                              <IconButton
                                onClick={removeFile}
                                size="small"
                                sx={{ ml: "2px" }}
                              >
                                <CloseIcon
                                  sx={{
                                    "&:hover": { color: "red" },
                                  }}
                                />
                              </IconButton>
                            )}
                        </span>
                      </Typography>{" "}
                    </>
                  </Grid>
                )}

                <Grid item xs={4}>
                  <Typography
                    className="font14 greyfirstheading"
                    gutterBottom
                    variant="subtitle1"
                  >
                    {show ? (
                      <div className="mt-4">
                        {"Client Imported Successfully"?.replace(
                          localData?.isClientNameChanged ? /client/gi : "",
                          localData?.isClientNameChanged
                            ? localData?.changedClientFieldName
                            : ""
                        )}{" "}
                        {count}/
                        {multiVehicles.clientDtoList &&
                          multiVehicles.clientDtoList.length}{" "}
                      </div>
                    ) : (
                      ""
                    )}
                  </Typography>
                </Grid>

                {Boolean(failedDataToExport.length) && (
                  <Grid item xs={8}>
                    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                      <Button
                        color="error"
                        sx={{ textTransform: "none" }}
                        size="large"
                        onClick={handleExportFailedData}
                      >
                        Export Failed Data
                      </Button>
                    </Box>
                  </Grid>
                )}
              </Grid>
              <Paper sx={{ width: "100%", mb: 2 }} elevation={1}>
                <TableContainer component={Paper} elevation={1}>
                  <Table size="small" aria-label="a dense table">
                    <TableHead style={{ background: "rgb(14 57 115 / 86%)" }}>
                      <TableCell style={{ color: "#fff" }}>S.No.</TableCell>
                      {exportArray &&
                        exportArray.length > 0 &&
                        exportArray.map((val) => {
                          return (
                            <>
                              {val !== null && val !== "Emp Code" ? (
                                <TableCell style={{ color: "#fff" }}>
                                  {val && val}
                                </TableCell>
                              ) : (
                                ""
                              )}
                            </>
                          );
                        })}
                      <TableCell style={{ color: "#fff" }}>Action</TableCell>
                      <TableCell style={{ color: "#fff" }}>Reason</TableCell>
                    </TableHead>

                    {multiVehicles &&
                      multiVehicles &&
                      multiVehicles.clientDtoList !== undefined &&
                      multiVehicles.clientDtoList.length > 0 &&
                      multiVehicles.clientDtoList
                        .slice(startIndex, endIndex)
                        .map((data, ind) => {
                          return (
                            <>
                              <TableRow>
                                <TableCell key={ind + 1}>{ind + 1}</TableCell>
                                {data.formData &&
                                  data.formData.length > 0 &&
                                  data.formData.map((val, index) => {
                                    return (
                                      <>
                                        <TableCell>
                                          {val &&
                                          val.value &&
                                          val.value !== null &&
                                          val.value !== undefined
                                            ? val.value
                                            : "NA"}
                                        </TableCell>
                                      </>
                                    );
                                  })}
                                <TableCell>
                                  {data && data.isClientImported === true ? (
                                    <CheckCircleIcon
                                      style={{ color: "green" }}
                                    />
                                  ) : data &&
                                    data.isClientImported === false ? (
                                    <CancelIcon style={{ color: "red" }} />
                                  ) : (
                                    ""
                                  )}
                                </TableCell>

                                <TableCell>
                                  {data && data.clientImportResponse
                                    ? data.clientImportResponse
                                    : "NA"}
                                </TableCell>
                              </TableRow>
                            </>
                          );
                        })}
                  </Table>
                </TableContainer>
                <TablePagination
                  rowsPerPageOptions={[10, 20, 50, 100, 500, 1000]}
                  component="div"
                  count={
                    multiVehicles.clientDtoList
                      ? multiVehicles.clientDtoList.length
                      : 0
                  }
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Paper>
              <div style={{ display: "none" }}>
                <table id="failedData">
                  <tr>
                    {exportArray &&
                      exportArray.length > 0 &&
                      exportArray.map((val) => {
                        return (
                          <>
                            {val !== null && val !== "Emp Code" ? (
                              <th>{val && val}</th>
                            ) : (
                              ""
                            )}
                          </>
                        );
                      })}
                  </tr>
                  {failedDataToExport.map((failedData, failedIndex) => {
                    return (
                      <tr key={failedIndex}>
                        {failedData.formData.map((dynamicData) => {
                          return (
                            <td key={dynamicData.uid}>
                              {dynamicData &&
                              dynamicData.value &&
                              dynamicData.value !== null &&
                              dynamicData.value !== undefined
                                ? dynamicData.value
                                : ""}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </table>
              </div>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancel}>{!show ? "Cancel" : "Done"}</Button>

            {Boolean(multiVehicles?.clientDtoList?.length) && !show && (
              <Button onClick={handleUpdate} autoFocus>
                Submit
              </Button>
            )}
          </DialogActions>
        </Dialog>
      </div>
    </div>
  );
}

function getFileExtension(fileName) {
  return fileName.substr(fileName.lastIndexOf(".") + 1);
}

function colName(n) {
  var ordA = "a".charCodeAt(0);
  var ordZ = "z".charCodeAt(0);
  var len = ordZ - ordA + 1;

  var s = "";
  while (n >= 0) {
    s = String.fromCharCode((n % len) + ordA) + s;
    n = Math.floor(n / len) - 1;
  }
  return s.toUpperCase();
}
